import { PropTypes } from "base/react-libs";
import { FlexTable, Link } from "@evertrue/et-components";
import JourneyFavoriteToggle from "apps/journeys/utils/journey-favorite-toggle";

const JourneysTable = ({ journeys = [], loading, toggleFavorite }) => {
  const totalMessage = () => {
    if (journeys.length === 1) {
      return `${journeys.length} Total Cadence`;
    }
    return `${journeys.length} Total Cadences`;
  };

  const columns = [
    {
      key: 1,
      width: 230,
      header: "Cadence Name",
      accessor: (data) => {
        return (
          <div className="journey-name">
            <JourneyFavoriteToggle journey={data} onClick={toggleFavorite} />
            <Link href={`/cadences/${data.id}`} title="journey-name">
              {data.name}
            </Link>
          </div>
        );
      },
    },
    {
      key: 2,
      width: 100,
      header: "Steps Due",
      accessor: (data) => {
        const {
          tasks_due_counts: { total = 0 },
        } = data;
        return total;
      },
    },
    {
      key: 3,
      width: 180,
      header: "Active Constituents",
      accessor: (data) => {
        return data.active_constituents;
      },
    },
    {
      key: 4,
      width: 150,
      header: "Total Duration",
      accessor: (data) => {
        const { duration_in_days = 0 } = data;
        return `${duration_in_days} Days`;
      },
    },
    {
      key: 5,
      width: 220,
      header: "Cadence Group",
      accessor: (data) => {
        return data.journey_group != null ? data.journey_group.name : "";
      },
    },
  ];

  return (
    <div>
      <div className="journeys-table--header">{totalMessage()}</div>
      <div className="journeys-table--body">
        <FlexTable caption="Lists" columns={columns} data={journeys} loading={loading} />
      </div>
    </div>
  );
};

JourneysTable.propTypes = {
  journeys: PropTypes.array,
  loading: PropTypes.bool,
  toggleFavorite: PropTypes.func,
};

export default JourneysTable;
